<div class="container-fluid navBarInvoice">
  <app-header-form
    [title]="title"
    [panelOpenState]="panelOpenState"
    [canShowClearFilter]="true"
    [canShowPanelFilter]="true"
    [canExportExcel]="true"
    [canCreateManualInvoice]="this.canCreateManualInvoice"
    (onClearFilterEvent)="onClearFilters()"
    (onPanelOpenStateEvent)="onShowFilter($event)"
    (onExportAsExcelEvent)="exportAsExcel()"
    (onCreateManualInvoiceEvent)="onCreateManual()"
    >
  </app-header-form>
</div>

<hr *ngIf="!panelOpenState">

<div class="container-fluid search-container">
  <div class="card" *ngIf="panelOpenState">
    <div class="card-body searchCard">
      <div fxLayout="row" fxLayoutGap="10px" >
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start">
          <div fxLayout="row">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Num&eacute;ro de facture</mat-label>
              <input matInput autocomplete="off" type="text" (keyup)="filterData(true)" [(ngModel)]="invoiceSearchCriteriaModel.Number">
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Nom du fournisseur</mat-label>
              <input matInput autocomplete="off" type="text" (keyup)="filterData(true)" [(ngModel)]="invoiceSearchCriteriaModel.SupplierName">
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxFlex="30" fxLayoutAlign="start" >
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>R&eacute;f&eacute;rence 1</mat-label>
                <ng-multiselect-dropdown [settings]="multipleSelectionWithSearchDropdownSettings"
                [data]="dropdownListAssets" (onFilterChange)="onAssetFilterChange($event)"
                (onDeSelect)="filterData(true)" (onSelect)="filterData(true)" placeholder='Sélectionner...'
                (onDeSelectAll)="onSelectAll($event, 'assets')" (onSelectAll)="onSelectAll($event, 'assets')"
                [(ngModel)]="selectedItemsAssets" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Soci&eacute;t&eacute; factur&eacute;e</mat-label>
                <ng-multiselect-dropdown [settings]="multipleSelectionWithSearchDropdownSettings"
                [data]="dropdownListRecipientEntities" (onFilterChange)="onRecipientEntityFilterChange($event)"
                (onDeSelect)="filterData(true)" (onSelect)="filterData(true)"
                (onDeSelectAll)="onSelectAll($event, 'recipientEntity')"
                (onSelectAll)="onSelectAll($event, 'recipientEntity')" placeholder='Sélectionner...'
                [(ngModel)]="selectedItemsRecipientEntities" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxFlex="30" fxLayoutAlign="start">
          <div fxLayout="row" class="dateStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Date de r&eacute;ception</mat-label>
              <custom-date-range-input
              (onDateChange)="dateChangeSearch($event);"
              typeFrom="FromReceptionDate"
              [valueFrom]="invoiceSearchCriteriaModel.FromReceptionDate"
              typeTo="ToReceptionDate"
              [valueTo]="invoiceSearchCriteriaModel.ToReceptionDate"></custom-date-range-input>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dateStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Date de facture</mat-label>
              <custom-date-range-input
              (onDateChange)="dateChangeSearch($event);"
              typeFrom="FromInvoiceDate"
              [valueFrom]="invoiceSearchCriteriaModel.FromInvoiceDate"
              typeTo="ToInvoiceDate"
              [valueTo]="invoiceSearchCriteriaModel.ToInvoiceDate"></custom-date-range-input>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dateStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Date d'&eacute;ch&eacute;ance</mat-label>
              <custom-date-range-input
              (onDateChange)="dateChangeSearch($event);"
              typeFrom="FromDueDate"
              [valueFrom]="invoiceSearchCriteriaModel.FromDueDate"
              typeTo="ToDueDate"
              [valueTo]="invoiceSearchCriteriaModel.ToDueDate"></custom-date-range-input>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyleMulti" *ngIf="isWaitingInvoice">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Code Famille</mat-label>
                <ng-multiselect-dropdown [settings]="expenseFamilyDropdownSettings" [(ngModel)]="selectedItemsExpenseFamilyTypes"
                  [data]="dropdownListExpenseFamilyTypes" (onSelect)="filterData(true)" placeholder='Sélectionner...'
                  (onSelectAll)="onSelectAll($event,'expenseFamily')"
                  (onDeSelectAll)="onSelectAll($event, 'expenseFamily')" (onDeSelect)="filterData(true)" class="search-dropdown">
                </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start">
          <div fxLayout="row" class="dropDownStyle" *ngIf="isDispatched">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Facture contrôlée</mat-label>
                <ng-multiselect-dropdown placeholder="" [settings]="dropdownSettings"
                [data]="dropdownListControl" (onDeSelect)="filterData(true)" (onSelect)="filterData(true)"
                placeholder='Sélectionner...' (onDeSelectAll)="onSelectAll($event, 'Check')"
                (onSelectAll)="onSelectAll($event,'Check')" [(ngModel)]="selectedItemsControl" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Situation de travaux</mat-label>
                <ng-multiselect-dropdown placeholder="" [settings]="dropdownSettings"
                [data]="dropdownListWorkingSituation" (onDeSelect)="filterData(true)" (onSelect)="filterData(true)"
                placeholder='Sélectionner...' (onDeSelectAll)="onSelectAll($event, 'WorkingSituation')"
                (onSelectAll)="onSelectAll($event,'WorkingSituation')" [(ngModel)]="selectedItemsWorkingSituation" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Reverse factoring</mat-label>
                <ng-multiselect-dropdown [settings]="dropdownSettings" [(ngModel)]="selectedItemsReverseFactoring"
                [data]="dropdownListReverseFactoring" (onSelect)="filterData(true)" placeholder='Sélectionner...'
                (onSelectAll)="onSelectAll($event,'ReverseFactoring')"
                (onDeSelectAll)="onSelectAll($event, 'ReverseFactoring')" (onDeSelect)="filterData(true)" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyleMulti" *ngIf="isWaitingInvoice">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Statut factures en attente</mat-label>
                <ng-multiselect-dropdown [settings]="dropdownSettings" [(ngModel)]="selectedItemsWaitingFlags"
                  [data]="dropdownListWaitingFlags" (onSelect)="filterData(true)" placeholder='Sélectionner...'
                  (onSelectAll)="onSelectAll($event,'waitingFlags')"
                  (onDeSelectAll)="onSelectAll($event, 'waitingFlags')" (onDeSelect)="filterData(true)" class="search-dropdown">
                </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyleMulti" *ngIf="isWaitingInvoice">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Corps de métier</mat-label>
                <ng-multiselect-dropdown [settings]="expenseTradeDropdownSettings" [(ngModel)]="selectedItemsExpenseTradeTypes"
                  [data]="dropdownListExpenseTradeTypes" (onSelect)="filterData(true)" placeholder='Sélectionner...'
                  (onSelectAll)="onSelectAll($event,'expenseTrade')"
                  (onDeSelectAll)="onSelectAll($event, 'expenseTrade')" (onDeSelect)="filterData(true)" class="search-dropdown">
                </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="search-result">
  <app-invoice-list [(data)]="data" [tableRowsActions]="tableRowActions" [tableMassActions]="tableMassActions"
    [onFiltersCleared]="onFiltersCleared" [onExportExcelCaller]="onExportExcelCaller" [exportFileName]="exportFileName" [tableIndications]="tableIndications"
    [canDownload]="true" [configKey]="configKey" ngDefaultControl>
  </app-invoice-list>
</div>
